import styled from 'styled-components';

export const LabelItem = styled.label`
  cursor: pointer;

  &:hover {
    background: ${(props) => props.theme.$gray100} !important;
  }
`;
